<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <public-header/>
        </template>
        <k-container class="py-10">
            <loading-progress></loading-progress>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import LoadingProgress from '@investor/components/LoadingProgress'
import PublicHeader from '@investor/components/PublicHeader';

function getCookie(id) {
    let value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
    return value ? unescape(value[2]) : null;
}

function setSessionCookie(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/api/investor";
}
function eraseCookie(name) {
    document.cookie = name+'=; domain=.kilde.sg; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
}

export default {
    components: {
        PublicHeader,
        LoadingProgress
    },
    async mounted() {
        try {
            let authCookie = getCookie('auth_inv_token');
            if (authCookie) {
                eraseCookie('auth_inv_token');
                setSessionCookie('auth_inv_token', authCookie);
                await this.$login(authCookie);
            } else {
                this.$router.push('/');
            }
        } catch (error) {
            console.error(error)
        }
    },
}
</script>
